module.exports = __webpack_public_path__ + "static/media/logo-192x192.b63d387d.png";